function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 1C5.89844 1 1 5.94141 1 12C1 18.1016 5.89844 23 12 23C18.0586 23 23 18.1016 23 12C23 5.94141 18.0586 1 12 1ZM12 21.625C6.67188 21.625 2.375 17.3281 2.375 12C2.375 6.71484 6.67188 2.375 12 2.375C17.2852 2.375 21.625 6.71484 21.625 12C21.625 17.3281 17.2852 21.625 12 21.625ZM11.3125 15.7812C10.7109 15.7812 10.2812 16.2539 10.2812 16.8125C10.2812 17.4141 10.7109 17.8438 11.3125 17.8438C11.8711 17.8438 12.3438 17.4141 12.3438 16.8125C12.3438 16.2539 11.8711 15.7812 11.3125 15.7812ZM13.2461 6.5H10.7109C9.12109 6.5 7.875 7.78906 7.875 9.37891V9.76562C7.875 10.1523 8.17578 10.4531 8.5625 10.4531C8.90625 10.4531 9.25 10.1523 9.25 9.76562V9.37891C9.25 8.5625 9.89453 7.875 10.7109 7.875H13.2461C14.0625 7.875 14.75 8.5625 14.75 9.37891C14.75 9.89453 14.4492 10.4102 13.9766 10.668L11.3984 11.957C10.9258 12.2148 10.625 12.7305 10.625 13.2891V14.0625C10.625 14.4492 10.9258 14.75 11.3125 14.75C11.6562 14.75 12 14.4492 12 14.0625V13.2891C12 13.2461 12 13.2031 12.043 13.1602L14.6211 11.8711C15.5234 11.3555 16.125 10.4102 16.125 9.37891C16.125 7.78906 14.8359 6.5 13.2461 6.5Z",
  fill: "currentColor"
});

const SvgHelpMd = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgHelpMd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/help-md.6453ecf3.svg";
export { ForwardRef as ReactComponent };